import gql from 'graphql-tag'

export const GET_DEBUG = gql`
  query {
    debug @client {
      disconnect,
      pingTimeout,
      agentStateBeforeDisconnect
    }
  }
`

export const SET_DISCONNECT = gql`
  mutation setDisconnect($timestamp: String) {
    setDisconnect(timestamp: $timestamp) @client
  }
`

export const SET_PING_TIMEOUT = gql`
  mutation setPingTimeout {
    setPingTimeout @client
  }
`

export const CLEAR_DISCONNECT = gql`
  mutation clearDisconnect {
    clearDisconnect @client
  }
`
